import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BreadcrumbsComponent } from './breadcrumbs.component';
import { TagModule } from '../tag/tag.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
    declarations: [
        BreadcrumbsComponent
    ],
    imports: [
        CommonModule,
        TagModule,
        FontAwesomeModule
    ],
    exports: [
        BreadcrumbsComponent
    ]
})
export class BreadCrumbsModule { }
